import { Form, Input, InputNumber, Select } from 'antd'
import { debounce } from 'lodash'
import { useEffect, useState } from 'react'
import { ListKeynValue } from 'services/report_services'
import { commonDatePresenter, commonDateStore, productPresenter, productStore, routingPresenter, routingStore } from 'stores/root_store'

const SearchForm = () => {

  const [maymoc, setMaymoc] = useState<any[]>([])
  const [routingList, setRoutingList] = useState<any[]>([])
  const [productList, setProductList] = useState<any[]>([])

  // list status danh sach trang thai
  const [listStatus, setListStatus] = useState<ListKeynValue[]>([]);

  const handleGetData = async (kw?: string) => {
    await commonDatePresenter.getListDropdownEquipmentV2(commonDateStore, kw ? kw : undefined)
    const newData = commonDateStore.dropdownEquipment.data.map(item => {
      return {
        value: item.key,
        label: item.value,
      }
    })
    setMaymoc(newData)
  }
  const handleGetDataRouting = async (kw?: string) => {
    await commonDatePresenter.getDropdownRouting(commonDateStore, kw ? kw : undefined)
    const newData = commonDateStore.dropdownRouting.data.map(item => {
      return {
        value: item.stepCode,
        label: item.stepName,
      }
    })
    setRoutingList(newData)
  }
  const handleGetDataProduct = async (kw?: string) => {
    await productPresenter.getListCategory(productStore, kw ? kw : '', null, null, 2)
    const newData = productStore.listCategory.data.map(item => {
      return {
        value: item.key,
        label: item.value,
      }
    })
    setProductList(newData)
  }

  const getListStatus = async () => {
    await commonDatePresenter.getDropdownByKeyword(
      commonDateStore,
      "WorkOrderStatusMes"
    );

    setListStatus(commonDateStore.dropdownByKey);
  };

  useEffect(() => {
    handleGetData();
    handleGetDataRouting();
    handleGetDataProduct('');
    getListStatus();

  }, [])


  return (
    <>
      <Form.Item name={'khachHang'} label={<strong>Khách hàng</strong>}>
        <Input placeholder="Nhập tên khách hàng" />
      </Form.Item>
      <Form.Item name={'tenTPBTP'} label={<strong>Tên TP/BTP</strong>}>
        <Input placeholder="Nhập Tên TP/BTP" />
      </Form.Item>
      {/*====================== Trạng thái WO ==========================*/}
      <Form.Item name={'trangThaiMES'} label={<strong>Trạng thái WO</strong>}>
        <Select
          mode="multiple"
          options={listStatus.map(i => ({
            label: i.value,
            value: i.key
          }))} />
      </Form.Item>
      <Form.Item name={'loaiLSX'} label={<strong>Loại lệnh sản xuất</strong>}>
        <Input placeholder="Nhập loại lệnh sản xuất" />
      </Form.Item>
      <Form.Item name={'soWO'} label={<strong>Số WO</strong>}>
        <Input placeholder="Nhập Số WO" />
      </Form.Item>
      <Form.Item name={'congDoanSanXuat'} label={<strong>Công đoạn sản xuất</strong>}>
        <Select
          allowClear
          options={routingList}
          onSearch={debounce(async (value) => await handleGetDataRouting(value), 500)}
          mode='multiple'
          placeholder="Vui lòng chọn"
          filterOption={false}
        />
      </Form.Item>
      <Form.Item name={'mayChuyenSanXuat'} label={<strong>Máy/ chuyền sản xuất</strong>}>
        <Select
          allowClear
          mode='multiple'
          options={maymoc}
          onSearch={debounce(async (value) => await handleGetData(value), 500)}
          filterOption={false}
          placeholder="Vui lòng chọn"
        />
      </Form.Item>

      <Form.Item name={'kichThuocSanPham'} label={<strong>Kích thước SP</strong>}>
        <Input />
        {/* <InputNumber
          style={{
            textAlignLast: 'end',
          }}
          className="!w-full"
          formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
          min={0} controls={false} /> */}
      </Form.Item>
      {/* nhóm SP */}
      <Form.Item name={'nhomSP'} label={<strong>Nhóm SP</strong>}>
        <Select
          allowClear
          mode='multiple'
          options={productList}
          onSearch={debounce(async (value) => await handleGetDataProduct(value), 500)}
          filterOption={false}
          placeholder="Vui lòng chọn"
        />
      </Form.Item>
    </>
  )
}

export default SearchForm